<template>
  <BaseAlert title="Cancelled" class="tw-block" theme="neutral">
    {{ event.asNotice(activeEmployment) }}
  </BaseAlert>
</template>

<script>
import BaseAlert from '@/components/BaseAlert'
import OvertimeCancelledEvent from '@/components/requests/overtime/events/OvertimeCancelledEvent'

export default {
  name: 'CancelledAlert',

  components: { BaseAlert },

  props: {
    overtime: {
      type: Object,
      required: true,
    },

    event: {
      type: OvertimeCancelledEvent,
      required: true,
    },
  },
}
</script>
